function BeerPouring5(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={65}
      height={130}
      viewBox="0 0 65 130"
      id="beer-pouring-5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.026 2.47h63.191c.546 50.866-22.736 101.7-11.818 125.233A2.313 2.313 0 0150.094 130H15.15a2.312 2.312 0 01-2.303-2.297C23.764 104.17.482 53.336 1.026 2.469z"
        fill="#C0BFBF"
      />
      <path
        d="M3.188 4.438h58.874c0 52.421-17.945 87.162-13.458 115.412H16.646C21.133 91.6 3.188 56.86 3.188 4.438z"
        fill="#D4D4D4"
      />
      <path
        d="M30.231 94.464a2.384 2.384 0 002.387 2.382c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38a2.384 2.384 0 00-2.387 2.38z"
        fill="#D4D4D4"
      />
      <path
        d="M44.587 59.911a3.124 3.124 0 003.128 3.118 3.123 3.123 0 003.129-3.118c0-1.724-1.4-3.12-3.129-3.12a3.125 3.125 0 00-3.128 3.12z"
        fill="#F8F8F8"
      />
      <path
        d="M32.621 130h17.473a2.313 2.313 0 002.304-2.297c-2.079-4.482-2.919-9.952-2.917-16.227.002-26.281 14.742-66.636 14.746-107.218 0-.597-.004-1.192-.01-1.789H32.62v1.968H62.06c0 52.422-17.946 87.162-13.46 115.412H32.622V130z"
        fill="#999"
      />
      <path
        d="M32.625 119.85h15.979C44.117 91.6 62.063 56.86 62.063 4.438H32.624v87.647c1.32 0 2.39 1.065 2.39 2.38a2.385 2.385 0 01-2.39 2.381v23.004zM47.72 56.788a3.123 3.123 0 013.129 3.12c0 1.723-1.4 3.12-3.129 3.12a3.124 3.124 0 01-3.128-3.12 3.125 3.125 0 013.128-3.12z"
        fill="#D4D4D4"
      />
      <path
        d="M32.618 96.846c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38v4.762zM47.715 63.03a3.123 3.123 0 003.129-3.119c0-1.724-1.4-3.12-3.129-3.12a3.125 3.125 0 00-3.128 3.12 3.124 3.124 0 003.128 3.118z"
        fill="#D4D4D4"
      />
      <path
        d="M10.168 5.543H4.763c-.692 32.6 15.105 75.56 14.275 113.409 3.047-51.248-9.504-65.102-8.87-113.409z"
        fill="#F8F8F8"
      />
      <path
        d="M43.563 41.268c0 1.745.93 3.16 2.077 3.16 1.148 0 2.079-1.415 2.079-3.16 0-1.746-.931-3.16-2.08-3.16-1.146 0-2.077 1.414-2.077 3.16zM19.952 35.778a3.125 3.125 0 003.13 3.118 3.124 3.124 0 003.129-3.118 3.125 3.125 0 00-3.129-3.12 3.125 3.125 0 00-3.13 3.12zM20.944 25.023a4.193 4.193 0 004.2 4.186c2.32 0 4.2-1.874 4.2-4.186 0-2.311-1.88-4.187-4.2-4.187a4.195 4.195 0 00-4.2 4.187z"
        fill="#D4D4D4"
      />
      <ellipse cx={32.682} cy={3.277} rx={31.744} ry={3.277} fill="#F8F8F8" />
      <path
        d="M60.047 34.749s5.791-13.567-2.692-19.222C54.83 13.845 51.45 6.453 44.288 7.29c-7.324-2.296-17.476 6.284-21.076 6.179-9.86-.29-10.286-1.058-15.95 2.627-5.61 5.087.008 18.654.008 18.654h52.777z"
        fill="#F8F8F8"
      />
      <path
        d="M4.016 28.17c19.047 86.856 13.868 87.02 12.796 91.878h32.612s-3.633-4.892 3.894-45.915c2.719-14.816 7.527-38.765 7.527-38.765s-21.147-15.524-32.59-7.197c-11.443 8.326-24.24 0-24.24 0z"
        fill="url(#prefix__paint0_linear_14338_42018)"
      />
      <path
        d="M18.323 37.76c.832 0 1.505-.506 1.505-1.13 0-.623-.673-1.129-1.505-1.129-.832 0-1.506.506-1.506 1.13 0 .623.674 1.129 1.506 1.129zM40.527 91.954a1.129 1.129 0 10.001-2.257 1.129 1.129 0 000 2.257zM41.07 42.494a1.797 1.797 0 103.594 0 1.797 1.797 0 00-3.593 0zM22.203 52.376a2.695 2.695 0 105.39 0 2.695 2.695 0 00-5.39 0zM21.707 82.922c.624 0 1.129-.674 1.129-1.505 0-.832-.505-1.506-1.13-1.506-.622 0-1.128.674-1.128 1.506 0 .83.506 1.505 1.129 1.505z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14338_42018"
          x1={49.505}
          y1={109.544}
          x2={16.112}
          y2={109.544}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset={1} stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default BeerPouring5;
